import { render, staticRenderFns } from "./DeclararSiniestro.vue?vue&type=template&id=7eb2453d&scoped=true&"
import script from "./DeclararSiniestro.vue?vue&type=script&lang=js&"
export * from "./DeclararSiniestro.vue?vue&type=script&lang=js&"
import style0 from "./DeclararSiniestro.vue?vue&type=style&index=0&id=7eb2453d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb2453d",
  null
  
)

export default component.exports